import { EDUCATION_LEVEL_MAP } from "@gokrew/models/employee";

export function getEducationLevelLabel(key?: string): string {
  if (!key) return "---";
  return EDUCATION_LEVEL_MAP[key] || key; // fallback if BE adds new type
}
